import request from '@/utils/request'

//登录
const postLogin = (parameter) => {
    return request({
        url: `/api/auth/login`,
        method: 'post',
        data: parameter
    })
}
// 验证码
const loginCode = () => {
    return request({
        url: `/api/auth/code`,
        method: 'get',
        // data:parameter
    })
}

//登出
const postLoginout = () => {
    return request({
        url: `/api/auth/logout`,
        method: 'post'
    })
}

//高德天气组件
const getHsbWeather = (params) => {
    return request({
        url: `https://restapi.amap.com/v3/weather/weatherInfo`,
        method: 'get',
        params
    })
}

export default {
    postLogin,
    postLoginout,
    getHsbWeather,
    loginCode
}